export default __webpack_public_path__ + "static/media/mobile_banner_health.1fe79117.jpg";